module.exports = __webpack_public_path__ + "static/media/starzplay.d9996f56.png";